export const SERVICES = [
  {
    slug: "private",
    n: "01",
    name: "Private 1:1 Sessions",
    tagline: "Deep transformational work, one honest conversation at a time.",
    image: "/images/session-room.jpg",
    body: "A closed room, no performance required. We slow the loop down until the pattern becomes visible, trace it to the root, and let the body put down what it no longer needs to carry. Available in person and online.",
    includes: [
      "60 minutes, fully private",
      "Pattern read + first honest remedy",
      "Written reflection prompts after the session",
      "In person or online",
    ],
  },
  {
    slug: "corporate",
    n: "02",
    name: "Corporate Counselling",
    tagline: "Workshops and leadership programmes for teams that run hot.",
    image: "/images/corporate-room.jpg",
    body: "Every organisation runs on the patterns of the people inside it. Custom workshops on emotional intelligence, communication under pressure, burnout and team dynamics — built around your rooms, not a template deck.",
    includes: [
      "Discovery call + needs mapping",
      "Half-day or full-day formats",
      "Leadership 1:1 add-ons",
      "Post-programme debrief for HR",
    ],
  },
  {
    slug: "meditation",
    n: "03",
    name: "Meditation & Guided Audio",
    tagline: "Practices for an analog nervous system.",
    image: "/images/meditation-still.jpg",
    body: "Short guided practices designed to be used in real life — before the meeting, before the reply, before you react. Begins with the free 7-Minute Nervous System Reset.",
    includes: [
      "7-Minute Nervous System Reset (free)",
      "Guided audio for sleep and reactivity",
      "Breath and stillness sequences",
      "Delivered to your inbox",
    ],
  },
  {
    slug: "community",
    n: "04",
    name: "Community & Circles",
    tagline: "Pattern recognition, out loud, together.",
    image: "/images/circle-still.jpg",
    body: "Small online circles for people done performing wellness. One theme, a handful of participants, and the kind of conversation you can't have at a dinner table.",
    includes: [
      "Small groups (8–12)",
      "Monthly themes",
      "Facilitated by Rajdeep",
      "Confidential by agreement",
    ],
  },
  {
    slug: "events",
    n: "05",
    name: "Events & Experiences",
    tagline: "Offline rooms where the real conversation can happen.",
    image: "/images/events-still.jpg",
    body: "Intimate offline gatherings — dinners, retreats and salons built around a single question. Analog by design: no screens, no networking, no performance.",
    includes: [
      "Curated intimate gatherings",
      "Single-question format",
      "Collaborations with hosts and venues",
      "By invitation or enquiry",
    ],
  },
];

export const FEES = [
  { label: "Private 1:1 Session (60 mins)", note: "In person or online", price: "₹2,100" },
  { label: "Recommended arc — 3 sessions", note: "The pattern usually needs more than one room", price: "₹6,300" },
  { label: "Recommended arc — 4 sessions", note: "See · Understand · Release · Realign", price: "₹8,400" },
  { label: "Corporate workshops & leadership programmes", note: "Half-day / full-day", price: "By quotation" },
  { label: "Community circles", note: "Per circle, small group", price: "By quotation" },
  { label: "7-Minute Nervous System Reset", note: "Guided audio practice", price: "Complimentary" },
];

export const STEPS_TO_BOOK = [
  {
    n: "1",
    title: "Reach out",
    body: "Send a few honest lines through the form, or message on WhatsApp. Rajdeep reads every enquiry herself.",
  },
  {
    n: "2",
    title: "Choose the room",
    body: "Private 1:1, a corporate programme, or a circle. We confirm the format, timing and whether it's in person or online.",
  },
  {
    n: "3",
    title: "Arrive and speak plainly",
    body: "No preparation needed. Bring the question you can't put down — the work starts the moment it's said out loud.",
  },
];

export const FAQS = [
  {
    q: "Is this therapy?",
    a: "No. T.A.L.K. is human-dynamics and transformation work — pattern recognition, insight and practical realignment. It sits alongside clinical care, not instead of it. If you are in clinical treatment, this work can complement it, and we'll say so plainly if a licensed clinician is the better room for you.",
  },
  {
    q: "How many sessions will I need?",
    a: "Most people find that three to four sessions is where the shift actually lands. The first makes the pattern visible; the ones after that make the new choice repeatable. There are no packages you're locked into — you decide after each conversation.",
  },
  {
    q: "What happens in a first session?",
    a: "You talk. Rajdeep listens for the pattern under the language, then names it back to you. Most people describe the first session as unnervingly accurate and oddly relieving. You leave with the pattern seen and one honest remedy to practise.",
  },
  {
    q: "Is it confidential?",
    a: "Completely. Nothing said in a session is shared, quoted or used in writing without your explicit consent. Corporate programmes are reported only in aggregate themes, never individual detail.",
  },
  {
    q: "Do you work online?",
    a: "Yes. Private sessions and circles run online for clients anywhere; in-person rooms are arranged by appointment. The work translates well — the conversation is the room.",
  },
  {
    q: "Is this a crisis service?",
    a: "No. If you are in immediate distress or at risk of harming yourself, please contact your local emergency number or a crisis helpline right away. This practice cannot respond to emergencies.",
  },
];

export const TERMS = [
  {
    title: "Payment",
    body: "Full payment is required before the session is confirmed. Fees are quoted in INR and are inclusive of applicable taxes unless stated otherwise.",
  },
  {
    title: "Rescheduling & cancellation",
    body: "Sessions can be rescheduled once, free of charge, with at least 24 hours' notice. Cancellations within 24 hours, or missed sessions, are charged in full.",
  },
  {
    title: "Session arcs",
    body: "Multi-session arcs are valid for three months from the date of purchase, are non-transferable, and cannot be assigned to another person.",
  },
  {
    title: "Scope of the work",
    body: "T.A.L.K. does not diagnose, treat or prescribe. Nothing shared in a session constitutes medical, psychiatric, legal or financial advice.",
  },
  {
    title: "Confidentiality",
    body: "Everything discussed stays between you and Rajdeep, except where disclosure is required by law or where there is a clear risk to life.",
  },
];
